import { Text, TextLinkButton } from 'braid-design-system';
import React, { type ReactNode } from 'react';

import { authClient } from 'src/modules/auth';

interface Props {
  children: ReactNode;
}

export const LogoutLink = ({ children }: Props) => (
  <Text tone="secondary" weight="medium">
    <TextLinkButton onClick={authClient.logout}>{children}</TextLinkButton>
  </Text>
);
